export default {
    /** 背景色 */
    background: "",
    /** 字体色 */
    color: "",
    /** 圆角 */
    radius: "",
    /** 边框线 */
    border: "",
    /** 字体大小 */
    size: ""
}
